import {
  formatNumber,
  formatNumberInput,
  formatNumberWithUnit,
  parseFormattedNumber,
} from "@/utils/numberFormat";
import { formatCurrency } from "@/utils/lib";

export default {
  install(app) {
    app.config.globalProperties.$formatNumber = formatNumber;
    app.config.globalProperties.$formatNumberWithUnit = formatNumberWithUnit;
    app.config.globalProperties.$formatNumberInput = formatNumberInput;
    app.config.globalProperties.$parseNumber = parseFormattedNumber;
    app.config.globalProperties.$formatCurrency = formatCurrency;
  },
};
